module.exports = __webpack_public_path__ + "static/img/yellow-right.cc4e5a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/yellow-right.png
// module id = c9iu
// module chunks = 0